import { Pipe, PipeTransform } from '@angular/core';
import { DeadlineTypeEnum } from '@zaoblako/shared/common/enums/deadline.type.enum';

const deadlineTypeNames: Record<DeadlineTypeEnum, string> = {
  [DeadlineTypeEnum.ABSOLUTE]: 'Абсолютный',
  [DeadlineTypeEnum.RELATIVE]: 'Относительный'
};

@Pipe({
  standalone: true,
  name: 'deadlineTypeName'
})
export class DeadlineTypeNamePipe implements PipeTransform {
  public transform(deadlineType: DeadlineTypeEnum): string {
    return deadlineTypeNames[deadlineType] || '';
  }
}
